/* cobra-galeria-zoom.js — pan de 1 dedo na foto ampliada (mobile).

   Problema: image_zoom = "none" (sem popup). O cliente amplia a foto com a pinça nativa
   do navegador (visualViewport), mas ao arrastar com 1 dedo a imagem "volta ao ponto":
   o carrossel da galeria (.slider--mobile: overflow-x auto + scroll-snap) captura o
   arrasto horizontal e faz snap de volta ao slide.

   Solução (sem popup, mantendo a pinça nativa que o Cobra já usa): enquanto
   visualViewport.scale > 1, marcamos a galeria com .cobra-vv-zoom — o CSS desliga o
   overflow/scroll-snap do carrossel, então o arrasto de 1 dedo passa a mover a imagem
   ampliada (pan nativo do visual viewport). Ao voltar a escala ~1, o carrossel volta ao
   normal. Só toca no comportamento quando há zoom; sem zoom, a troca de slide por swipe
   segue igual. */
(function () {
  var vv = window.visualViewport;
  if (!vv) return; // desktop / navegadores sem visual viewport: nada a fazer

  var LIMIAR = 1.02; // folga p/ não disparar em micro-variações de escala
  var zoomed = false;
  var raf = 0;

  function galerias() {
    return document.querySelectorAll('media-gallery');
  }

  function aplica() {
    raf = 0;
    var agora = vv.scale > LIMIAR;
    if (agora === zoomed) return;
    zoomed = agora;
    galerias().forEach(function (g) {
      g.classList.toggle('cobra-vv-zoom', agora);
    });
  }

  function agenda() {
    if (!raf) raf = requestAnimationFrame(aplica);
  }

  // 'resize' do visualViewport dispara na pinça (mudança de escala); 'scroll' no pan.
  vv.addEventListener('resize', agenda);
  vv.addEventListener('scroll', agenda);
})();
